/* unplugin-vue-components disabled */import { render } from "./Requisition.vue?vue&type=template&id=41249ce5&scoped=true&ts=true"
import script from "./Requisition.vue?vue&type=script&lang=ts"
export * from "./Requisition.vue?vue&type=script&lang=ts"

import "./Requisition.vue?vue&type=style&index=0&id=41249ce5&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41249ce5"]])

export default __exports__